import { EmeraldConfigRequestModel, EmeraldConfigResponseModel } from '../../packages/contactUs/models/configModels';
import { BcqrResult, Modality, UserInfo, AnswerDeskContentModel, AnswerDeskModalityType, AnswerDeskModality, AlchemyResult, AlchemyInsightModel, ContentType } from '../apiModels';
/* eslint-disable no-bitwise */
// enum constants
export enum NavBarSettings {
  None = 0,
  ShowBackButton = 1 << 0,
  ShowHomeButton = 1 << 1,
  ShowSearch = 1 << 2,
  All = ShowBackButton | ShowHomeButton | ShowSearch,
}

export const enum Environment {
  SOC,
  agavePane,
  nonAgavePane,
  Teams,
  OutlookDotCom,
  ThirdParty,
  GetHelp
}

export enum AwaMetaTagType {
  AssetID = 'awa-asst',
  AuthType = 'awa-authType',
  TenantId = 'awa-tenantId',
  SessionId = 'awa-sessionId',
  PageType = 'awa-pageType',
  ExperienceVersion = 'awa-experienceVersion',
  ExperimentId = 'awa-experimentId',
  VariationId = 'awa-variationId',
  Product = 'awa-prdct',
  ReferApp = 'awa-referapp',
  SourceApp = 'awa-sourceapp',
  OperatingSystem = 'awa-os',
  InAppExternalNavigationType = 'awa-InAppExternalNavigationType',
  BuildVersion = 'awa-stv',
  CorrelationId = 'ms.correlationId',
  Market = 'awa-market',
  EmsSessionId = 'awa-ems-sessionid',
}

export enum URLs {
  SmcEndpoint = 'https://support.microsoft.com',
  SOC = 'home/contact',
  SMCExperiment = 'home/expcontact',
  GroupMe = 'groupme/contact',
  Edu = 'home/contact/education',
  RaveChatWidgetLink = 'https://widget.rave.office.net/chat?partner={0}&requestid={1}{2}',
  UnAuthRaveChatWidgetLink = 'https://widget.rave.office.net/nomsachat/redirect?partner={0}&requestid={1}',
  // Omnichannel Live Chat Widget link
  OmnichannelLCWLink = '/{0}/home/livechatwidget?theme={1}{2}&customcontext={3}&x-ems-sessionid={4}',
  CommunityLink = 'https://answers.microsoft.com',
  ServiceAgreementLink = 'https://support.microsoft.com/{0}/topic/microsoft-customer-support-service-agreement-3b3b6a44-f4ca-7a22-f77b-0b28f99a507a',
  AlchemySolutionsUrlLegacy = '/home/GetAlchemyContentAsync',
  AlchemySolutionsUrlV1 = '/api/contactus/v1/GetAlchemySolutions',
  TeamsAuthStart = '/home/contact/teams-auth-start',
  TeamsAuthEnd = '/home/contact/teams-auth-end',
  AdminPortalRequestHistory = 'https://portal.office.com/adminportal/home#/support/requests',
  AddLogs = '/api/contactus/v1/AddLogs',
  OfficeLink = '/office.com',
  TeamsUpdatedVersion = 'https://teams.microsoft.com/l/app/2c3c47ad-a816-4408-926d-13dfe15a3d0a?source=app-details-dialog',
  IconBaseUrl = 'https://static2.sharepointonline.com/files/fabric/assets/icons/',
  Win10Eos = 'https://support.microsoft.com/{locale}/windows/windows-10-supports-ends-on-october-14-2025-2ca8b313-1946-43d3-b55c-2b95b107f281',
  OfficeEos = 'https://support.microsoft.com/{locale}/office/end-of-support-for-office-2016-and-office-2019-818c68bc-d5e5-47e5-b52f-ddf636cf8e16'
}

export enum SourceApps {
  SMCIVR = 'smcivr1',
  SMCIVR2 = 'smcivr2',
  SurfaceIVR = 'surfaceivr1',
  SurfaceIVR2 = 'surfaceivr2',
  SignUp = 'signup1',
  GroupMe = 'groupme1',
  SMCExp = 'smcexp1',
  SMC2 = 'smc2',
  SOC = 'soc1',
  SOC2 = 'soc2',
  Teams = 'teams1',
  Teams2 = 'teams2',
  Proactive = 'proactive1',
  TeamsAdmin = 'teamsadmin1',
  TeamsAdmin2 = 'teamsadmin2',
  SurfaceApp = 'surfaceapp1',
  SurfaceWeb = 'surfaceweb1',
  LightHouse = 'lighthouse1',
  // thirdParty apps
  TechData1 = 'techdata1',
  TechData2 = 'techdata2',
  Synnex1 = 'synnex1',
  OfficeDotCom = 'officedotcom1',
  OutlookAdmin = 'outlookadmin1',
  AMC = 'amc1',
  OneDriveWeb= 'onedriveweb1',
  GetHelp1 = 'gethelp1',
  GetHelpSkylight = 'gethelpskylight',
  SmbHub1 = 'smbhub1',
  VsbHub1 = 'vsbhub1',
  W365C1 = 'w365c1',
  Edu = 'edu1',
  SurfaceApp2 = 'surfaceapp2',
}

export const UnAuthEntryPointToSourceAppMapping: { [key: string]: string} = {
  'signup': SourceApps.SignUp,
  'smbhub': SourceApps.SmbHub1,
  'vsbhub': SourceApps.VsbHub1
}

export enum Namespaces {
  WinWord = 'winword',
  Powerpoint = 'powerpnt',
  Excel = 'excel',
  WordWac = 'WDWAENDUSER',
  ExcelWac = 'XLWAENDUSER',
  PowerPointWac = 'PPWAENDUSER',
}

export enum M365UpsellNonAgentModalityId {
  m365Upsell = 'm365 upsell smc',
  agentAssistSubscription = 'm365 upsell smc agentassistsubscription',
  agentAssistSubscriptionChatWeighted = 'm365 upsell smc agentassistsubscription chatweighted',
  payPerIncident = 'm365 upsell smc payperincident',
  payPerIncidentChatWeighted = 'm365 upsell smc payperincident chatweighted'
}

export enum OutdatedDevicesAlertEnabledComponent {
  SelfHelpAlchemy = 'alchemy solutions',
  ModalitySection = 'ticket creation'
}

export enum VsbUpsellAlertEnabledComponent {
  SelfHelpAlchemy = 'alchemy solutions',
}

export class RegExpPatterns {
  public static PhoneNumber: RegExp = /^[0-9]{4,25}$/;
  // Common strings patterns used to build other more complex regular expressions
  public static IPv4Address =
    '(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])';
  // Domain name, can't enforce the max 254 characters length due to use in different regexps (preceeded/succceeded by various chars)
  // We'll require at least 2 labels e.g. domain.com, no dot termination
  public static DomainNameLabel = '[a-z0-9]([a-z0-9\\-]{0,61}[a-z0-9])?';
  public static DomainName = `((${RegExpPatterns.DomainNameLabel}\\.)+${RegExpPatterns.DomainNameLabel})`;
  // Email user names
  // Per standard, the local-part of an email address can consist of any combination of alphabet characters, digits,
  // or any of the following special characters: !#$%&'*+-/=?^_`{|}~ in groups separated by dots. Dots cannot be consequtive,
  // and cannot start or end the groups (see atom in https://tools.ietf.org/html/rfc5322#page-12)
  // The fragment below excludes characters that cannot be in these groups: <>()[]\.,;:@ and spaces
  // Can't enforce the max 64 characters length due to use in different regexps (preceeded/succceeded by various chars)
  public static EmailUserName =
    '([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)';
  // Email address in format user@domain or user@ipv4address
  // REVIEW: Why are we not supporting user@ipv6address, per https://tools.ietf.org/html/rfc5321#section-2.3.1 ?
  public static EmailAddress = `${RegExpPatterns.EmailUserName}@(${RegExpPatterns.DomainName}|${RegExpPatterns.IPv4Address})`;
  public static EmailAddressSeparator = '\\s*;\\s*';
  public static MultipleEmailRegex: RegExp = new RegExp(
    `^${RegExpPatterns.EmailAddress}(${RegExpPatterns.EmailAddressSeparator}${RegExpPatterns.EmailAddress})*$`,
    'i'
  );
}

// constants
export const ContactUsHistoryTag = 'CONTACT_US_HOME';

export const FeedbackQueryTag = 'givefeedback';
export const UnAuthBranchingQuery = 'UnAuth_Assist_Sign_In_Flow_9009808';
export const LinkForLoggingAttribute = 'data-log-click';
export const ContentAttribute = 'content';

export const emeraldDeepLinkQueryParameter = 'LinkQuery=';
export const isCMCRequestCreationDeeplinkKey = 'emeraldcmc-';
export const getHelpDeepLinkQueryParameter = 'SearchKey=';
export const isWindowsCopilotRequestCreationDeeplinkKey = 'emeraldwindowscopilot-';

export const HttpStatusCodeTooManyRequest = 429;

// 20 is ideal width for outlook.com pane, 50 works for gethelp app but can be adjusted if needed
export const textAreaColSizeOutlook = 20;
export const textAreaColSizeWindowsCopilotDeepLink = 50;

export const EmeraldConfigFallbackBody: EmeraldConfigRequestModel = {
  Host: null,
  Platform: null,
  Market: 'en-US',
  Version: '16',
  Namespace: 'IWAPP',
  LCID: null,
};

export enum ErrorStrings {
  title = 'L_ContactUs_ErrorFallback_Title',
  description = 'L_ContactUs_ErrorFallback_Description',
  label = 'L_ContactUs_ErrorFallback_Label',
  fallbackTitle = 'Sorry, something went wrong.',
  fallbackDescription = 'Please try again later.',
  fallbackLabel = 'Error Id',
}

export const ChatWeightedId = 'chatweighted';

export const FallbackTheme = 'white';

export const OutlookDotComAlchemyTheme = 'OutlookDotCom';

export const OutlookDotComAppVer = 'owc150';

export const OutlookDotComHostOrigin = 'https://outlook.live.com';

export const HelpIdInAppContactSupportAddIn = '160272'; // The HID_InAppContactSupportAddIn help id variable defined in Misc.helpids.h

export const AMCSignedInUserLink = 'https://answers.microsoft.com/{market}/site/switchto';

export const C2CSkylightNonAgentModalityId = 'C2C Skylight';

export const C2CSkylightOfficeNonAgentModalityId = 'C2C Skylight Office';

export const SupportedWindowParentOrigins = ['https://admin-ignite.microsoft.com', 'https://admin.microsoft.com'];

// constants for mocking in tests
export const MockHomeUrl = '/en-US/f1/topic/f35b8f14-67a6-44f2-8ba3-935c33056571?NS=WDWAENDUSER&version=16&context=%7B%22ThemeId%22:5%7D&EntryPoint=true';

export const MockBcqrArray: BcqrResult[] = [
  { Content: 'test content 1', Guid: '123', Url: 'www.microsoft.com', Title: 'BCQR Title 1' },
  { Content: 'test content 2', Guid: '456', Url: 'www.microsoft.com', Title: 'BCQR Title 2' },
];

export const MockAlchemyResponse: AlchemyResult = {
  TopResults: null,
  Theme: {
    Name: null,
    Confidence: 0,
    SecondaryTheme: null,
    SecondaryThemeConfidence: 0,
  },
  Solutions: [{
    Title: 'Focused Inbox for Outlook - Office Support',
    Description: 'Turn on Focused Inbox, and move items between Focused and Other folders, Includes instructions for Outlook 2016, Outlook on the web, Outlook.com, Hotmail,com, Mail and Calendar for Windows 10, and Outlook 2016 for Mac.',
    Confidence: 0,
    URI: 'https://support.office.com/en-us/article/Focused-Inbox-for-Outlook-f445ad7f-02f4-4294-a82e-71d8964e3978?wt.mc_id=O365_Portal_MMaven',
    Source: 'bing',
    ContentType: ContentType.SMC,
  }],
  Insights: [{
    Title: 'Turn off Focused Inbox',
    Description: '<div><ol><li>At the top of the page, select <img src="data:image/png;base64,iVBORw0KG" data-linktype="external"> to open the Settings pane.</li>↵<li>In the Settings pane, move the <strong>Focused Inbox</strong> toggle to off.</li>↵</ol>↵<p>For more information, see <a href="https://support.office.com/article/f714d94d-9e63-4217-9ccb-6cb2986aa1b2?wt.mc_id=Office_Outlook_com_Alchemy#bkmk_outlookcom" data-linktype="external" target="_blank" data-placeholder-to-wire-clientevents >Turn off Focused Inbox</a>.</p></div>',
    TextFormat: '',
    BucketId: 8000001,
    BucketName: 'Outlook.com How to turn off focused inbox',
    BucketConfidence: 0,
    BucketPercentile: 0,
    RuleID: 105,
    SolutionId: '',
    SolutionType: '',
    IsExpanded: true,
  }],
  AIInsights: {
    GPTInsight: 'AI Assisted Insight',
    FollowUpQuestions: null,
    ScrubbedQuery: 'outlook help'
  },
  Query: 'outlook help',
  Incidents: [],
  CorrelationId: '1129ae07-0775-4254-9dc2-b06fe1d20ec2',
  DebugInfo: '',
  ThemeRoutingData: {
    'CorrelationId': null,
    'Locale': 'en-US',
    'AlchemyTheme': 'Accounts, Profiles and Login (Windows)',
    'Nodes': [
      {
        'Id': 'L2_Accounts_Pwd',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Password Reset/Recovery',
        'Label': 'Password Reset/Recovery',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Accounts_forgotUser',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Forgot my username',
        'Label': 'Forgot my username',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Accounts_Signin',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Account sign-in questions',
        'Label': 'Account sign-in questions',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Accounts_Security',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Manage account security',
        'Label': 'Manage account security',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Accounts_ManageProfile',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Manage profile information',
        'Label': 'Manage profile information',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Accounts_Close',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Close my account',
        'Label': 'Close my account',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Accounts_List',
        'Level': 'L2',
        'LevelLabel': {
          'Label': 'Category',
          'Placeholder': 'Select your support category',
        },
        'Value': null,
        'Label': null,
        'Children': [
          'L2_Accounts_Pwd',
          'L2_Accounts_forgotUser',
          'L2_Accounts_Signin',
          'L2_Accounts_Security',
          'L2_Accounts_ManageProfile',
          'L2_Accounts_Close',
        ],
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L1_Windows_L0_AccountsOfforWin',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Windows',
        'Label': 'Windows',
        'Children': null,
        'ChildrenPointer': 'L2_Accounts_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L1_M365_L0_AccountsOfforWin',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Microsoft 365 and Office',
        'Label': 'Microsoft 365 and Office',
        'Children': null,
        'ChildrenPointer': 'L2_Accounts_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L1_Xbox_L0_AccountsOfforWin',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Xbox',
        'Label': 'Xbox',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L3_Surface_Pro',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Surface Pro',
        'Label': 'Surface Pro',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L3_Surface_Book',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Surface Book',
        'Label': 'Surface Book',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L3_Surface_Go',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Surface Go',
        'Label': 'Surface Go',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L3_Surface_Laptop',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Surface Laptop',
        'Label': 'Surface Laptop',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L3_Surface_Studio',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Surface Studio',
        'Label': 'Surface Studio',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L3_Surface_Earbuds',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Surface Earbuds',
        'Label': 'Surface Earbuds',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L3_Surface_Duo',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Surface Duo',
        'Label': 'Surface Duo',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L3_Surface_Access',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Surface Access',
        'Label': 'Surface Access',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L3_Surface_List',
        'Level': 'L3',
        'LevelLabel': {
          'Label': 'Product family',
          'Placeholder': 'Select a product family',
        },
        'Value': null,
        'Label': null,
        'Children': [
          'L3_Surface_Pro',
          'L3_Surface_Book',
          'L3_Surface_Go',
          'L3_Surface_Laptop',
          'L3_Surface_Studio',
          'L3_Surface_Earbuds',
          'L3_Surface_Duo',
          'L3_Surface_Access',
        ],
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Surface_Power',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Won’t power on',
        'Label': 'Won’t power on',
        'Children': null,
        'ChildrenPointer': 'L3_Surface_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Surface_Crack',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Cracked screen',
        'Label': 'Power supply tip won’t light',
        'Children': null,
        'ChildrenPointer': 'L3_Surface_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Surface_Light',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Power supply tip won’t light',
        'Label': 'Power supply tip won’t light',
        'Children': null,
        'ChildrenPointer': 'L3_Surface_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Surface_Support',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Technical support',
        'Label': 'Technical support',
        'Children': null,
        'ChildrenPointer': 'L3_Surface_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Surface_Hardware',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Hardware problem (e.g. screen, battery, audio, keyboard)',
        'Label': 'Hardware problem (e.g. screen, battery, audio, keyboard)',
        'Children': null,
        'ChildrenPointer': 'L3_Surface_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Surface_Pre',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Pre-order, purchase a device or extended warranty',
        'Label': 'Pre-order, purchase a device or extended warranty',
        'Children': null,
        'ChildrenPointer': 'L3_Surface_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Surface_Reset',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Password reset',
        'Label': 'Password reset',
        'Children': null,
        'ChildrenPointer': 'L3_Surface_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Surface_Safety',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Safety concern',
        'Label': 'Safety concern',
        'Children': null,
        'ChildrenPointer': 'L3_Surface_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_Surface_List',
        'Level': 'L2',
        'LevelLabel': {
          'Label': 'Category',
          'Placeholder': 'Select your support category',
        },
        'Value': null,
        'Label': null,
        'Children': [
          'L2_Surface_Power',
          'L2_Surface_Crack',
          'L2_Surface_Light',
          'L2_Surface_Support',
          'L2_Surface_Hardware',
          'L2_Surface_Pre',
          'L2_Surface_Reset',
          'L2_Surface_Safety',
        ],
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L1_Surface_L0_AccountsOfforWin',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Surface',
        'Label': 'Surface',
        'Children': null,
        'ChildrenPointer': 'L2_Surface_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_MSN_Billing',
        'Level': null,
        'LevelLabel': null,
        'Value': 'MSN Explorer Premium/Dialup Billing',
        'Label': 'MSN Explorer Premium/Dialup Billing',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_MSN_Support',
        'Level': null,
        'LevelLabel': null,
        'Value': 'MSN Explorer Premium/Dialup Technical Support',
        'Label': 'MSN Explorer Premium/Dialup Technical Support',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_MSN_Comm',
        'Level': null,
        'LevelLabel': null,
        'Value': 'MSN Community',
        'Label': 'MSN Community',
        'Children': null,
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L2_MSN_List',
        'Level': 'L2',
        'LevelLabel': {
          'Label': 'Category',
          'Placeholder': 'Select your support category',
        },
        'Value': null,
        'Label': null,
        'Children': [
          'L2_MSN_Billing',
          'L2_MSN_Support',
          'L2_MSN_Comm',
        ],
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
      {
        'Id': 'L1_MSN_L0_AccountsOfforWin',
        'Level': null,
        'LevelLabel': null,
        'Value': 'MSN',
        'Label': 'MSN',
        'Children': null,
        'ChildrenPointer': 'L2_MSN_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L1_OtherProducts_L0_AccountsOfforWin',
        'Level': null,
        'LevelLabel': null,
        'Value': 'Other Products',
        'Label': 'Other Products',
        'Children': null,
        'ChildrenPointer': 'L2_Accounts_List',
        'AlchemyThemes': null,
      },
      {
        'Id': 'L0_AccountsOfforWin',
        'Level': 'L1',
        'LevelLabel': {
          'Label': 'Products and services',
          'Placeholder': 'Select your product or service',
        },
        'Value': null,
        'Label': null,
        'Children': [
          'L1_Windows_L0_AccountsOfforWin',
          'L1_M365_L0_AccountsOfforWin',
          'L1_Xbox_L0_AccountsOfforWin',
          'L1_Surface_L0_AccountsOfforWin',
          'L1_MSN_L0_AccountsOfforWin',
          'L1_OtherProducts_L0_AccountsOfforWin',
        ],
        'ChildrenPointer': null,
        'AlchemyThemes': null,
      },
    ],
  },
  OutdatedWindowsDevices: [],
};

export type Dialog = {
  id: string;
  preselectedlevel0: string;
  preselectedlevel1: string;
  preselectedlevel2?: string;
  preselectedlevel3?: string;
};

export type DialogDict = { [id: string]: Dialog };

export const DialogMap: DialogDict = {
  '50d38b8d-34f7-4bb7-99cb-b9e16a2bf40f': {
    // [Commerce][Billing] Unknown Purchases - I've been charged twice
    id: '50d38b8d-34f7-4bb7-99cb-b9e16a2bf40f',
    preselectedlevel0: 'Commerce (Office)',
    preselectedlevel1: 'Microsoft 365 and Office',
    preselectedlevel2: 'Billing and payment updates',
  },
  'db12bafe-4129-4813-b12f-9d791672cab5': {
    // [MSDT] Printer - [DAF] Printer Troubleshooter
    id: 'db12bafe-4129-4813-b12f-9d791672cab5',
    preselectedlevel0: 'Devices and Drivers',
    preselectedlevel1: 'Windows',
    preselectedlevel2: 'Devices and drivers',
  },
  '6075581b-7555-40b8-814f-f81604b17175': {
    // [MSA] Add or change profile information in my Microsoft account
    id: '6075581b-7555-40b8-814f-f81604b17175',
    preselectedlevel0: 'Accounts, Profiles and Login (Windows)',
    preselectedlevel1: 'Microsoft 365 and Office',
    preselectedlevel2: 'Manage profile information',
  },
  '8c9e609f-f7e8-4765-94e2-4b6fe7239e14': {
    // [WINDOWS] Activate Windows 11
    id: '8c9e609f-f7e8-4765-94e2-4b6fe7239e14',
    preselectedlevel0: 'Activation',
    preselectedlevel1: 'Windows',
  },
  'c04aed9e-6d38-49bb-a1d4-513b82da3ab5': {
    // [WINDOWS][MSA] Help signing in with Windows Hello PIN!
    id: 'c04aed9e-6d38-49bb-a1d4-513b82da3ab5',
    preselectedlevel0: 'Accounts, Profiles and Login (Windows)',
    preselectedlevel1: 'Windows',
    preselectedlevel2: 'Password Reset/Recovery',
  },
  '13dadf73-14cc-4cc7-82b8-5e87245a81f1': {
    // [WINDOWS] Update or Reinstall Drivers in Windows
    id: '13dadf73-14cc-4cc7-82b8-5e87245a81f1',
    preselectedlevel0: 'Devices and Drivers',
    preselectedlevel1: 'Windows',
    preselectedlevel2: 'Devices and drivers',
  },
  '6a3e7004-8c4a-47a5-8810-ebc4f4e24eb3': {
    // [OneDrive] Trouble syncing OneDrive
    id: '6a3e7004-8c4a-47a5-8810-ebc4f4e24eb3',
    preselectedlevel0: 'OneDrive',
    preselectedlevel1: 'Microsoft 365 and Office',
    preselectedlevel2: 'Technical Support',
  },
  '515838d7-8652-4fe0-b2ab-5676a4aa208e': {
    // [OneDrive][USQ] How does Microsoft storage work?
    id: '515838d7-8652-4fe0-b2ab-5676a4aa208e',
    preselectedlevel0: 'OneDrive',
    preselectedlevel1: 'Microsoft 365 and Office',
    preselectedlevel2: 'Technical Support',
  },
};

export const MockUserNoticesResponse: AlchemyInsightModel[] = [
  {
    Title: 'This is a sample user notice',
    Description: '<div>Sample user notice</div>',
    TextFormat: null,
    BucketId: 9010863,
    BucketName: 'ContactUsNotices',
    BucketConfidence: 0.0,
    BucketPercentile: 0.0,
    RuleID: 12588,
    SolutionType: 'CustomText',
    SolutionId: null,
    IsExpanded: true,
  },
];

export const MockModalityArray: Modality[] = [
  {
    type: 'callback',
    link: 'https://support.microsoft.com/en-us/contact/callback/37/?disability=false&mode=live&partnerId=office',
    hoopsLink: 'https://support.microsoft.com/en-us/contact/hoops/callback/37/?disability=false&mode=live&partnerId=office',
  },
  {
    type: 'chat',
    link: 'https://support.microsoft.com/en-us/contact/chat/37/?disability=false&mode=live&partnerId=office',
    hoopsLink: 'https://support.microsoft.com/en-us/contact/hoops/chat/37/?disability=false&mode=live&partnerId=office',
  },
  {
    type: 'community',
    link: 'http://answers.microsoft.com/en-us/office/',
    hoopsLink: 'http://answers.microsoft.com/en-us/office/',
  },
];

export const MockUserInfo: UserInfo = {
  Cid: '1234',
  GivenName: '1234',
  IdentityProviderUrl: '1234',
  IsWindowsLiveDogfoodUser: false,
  Provider: 'msa',
  Surname: '1234',
  MemberName: '1234',
  IsAdmin: false,
  IsBAUser: false,
  IsBATenant: false,
  LegalAgeGroup: 3,
  DataBoundary: ['NONE'],
  IsDfM: false,
  UserPuid: '00000000-0000-0000-0000-000000000000',
  TenantId: '00000000-0000-0000-0000-000000000000',
  Entitlement: null,
};

export const MockChatModality: AnswerDeskModality = {
  ShowModality: true,
  LoggingBehavior: 'CHATINITIATE',
  IconClass: 'opChat',
  IconText: 'Live Chat',
  IconTextId: 'ocChatText',
  LinkId: 'ocChat',
  Link: '/en-us/home/confirmcontact?input=test&mode=chat&queue=setup&product=office',
  Info: null,
};

export const mockModalitiesMap = (): Map<AnswerDeskModalityType, AnswerDeskModality> => {
  const modalitiesMap = new Map<AnswerDeskModalityType, AnswerDeskModality>();

  modalitiesMap.set(AnswerDeskModalityType.chat, MockChatModality);

  return modalitiesMap;
};

export const MockAnswerDeskContentModel: AnswerDeskContentModel = {
  Message: null,
  Modalities: mockModalitiesMap(),
};

const isLoadResourcesEnabled = !!window.emeraldContext && !!window.emeraldContext.isLoadResourcesEnabled;

export const MockInitDataResponse: EmeraldConfigResponseModel = {
  DefaultArticleGuid: 'f35b8f14-67a6-44f2-8ba3-935c33056571',
  Namespace: 'WDWAENDUSER',
  NavigationBarSettings: NavBarSettings.All,
  Market: 'en-US',
  AppVer: 'WAW160',
  Version: '16',
  SupportSettingsConfig: {
    LocalizedDaysOfWeek: {
      LanguageName: 'English',
      DaysOfWeek: { Sunday: 'Sun', Monday: 'Mon', Tuesday: 'Tue', Wednesday: 'Wed', Thursday: 'Thu', Friday: 'Fri', Saturday: 'Sat' },
    },
    IsAutoSuggestEnabled: false,
  },
};

export const ContactUsPageType = 'ContactUs';
export const UnauthTicketProvider = 'MSA';
export const ContactUsAssetID = 'S.HP.MaxFunnel';
export const ContactUsEntryPoint = 'ContactUs';

export const ContactUsExperienceVersion = '0.0';

export const QueryMaxCharacter = 250;
export const SMCExperimentQueryMaxCharacter = 80;

export const OutdatedDevicesAlertConstants = {
  contentIds: {
    alert: 'alert',
    dismissIcon: 'dismissIcon',
    expandIcon: 'expandIcon',
    closeIcon: 'closeIcon',
    expandLink: 'expandLink',
    closeLink: 'closeLink',
    windowsUpdateArticleLink: 'windowsUpdateArticleLink',
    windowsUpdateInvokerButton: 'windowsUpdateInvokerButton',
  },
  area: {
    modalitySection: 'modalitiesSectionOutdatedDevicesAlert',
    selfHelpAlchemy: 'selfHelpAlchemyOutdatedDevicesAlert',
  },
  formnm: 'maxFunnel',
};

export const VsbUpsellAlertConstants = {
  contentIds: {
    alert: 'alert',
    dismissIcon: 'dismissIcon',
    closeIcon: 'closeIcon',
    closeLink: 'closeLink',
    seePlansButton: 'seePlansButton',
  },
  area: {
    selfHelpAlchemy: 'selfHelpAlchemyVsbUpsellAlert',
  },
  formnm: 'maxFunnel',
};

// ContactUs auto suggest constants used in SOC and InApp experiences
export const AutoSuggestConstants = {
  cssClassName: 'supSuggestionItem',
  dataKeyName: 'autoSuggest_',
  filterClause: `(locale eq '{0}' or locale eq '{1}') and workloadId eq '{2}'`,
  headers: {
    Accept: 'application/json;odata.metadata=none',
    'Content-Type': 'application/x-www-form-urlencoded; odata.metadata=none',
    'api-key': '',
  },
  characterMinimum: 2,
  characterMaximum: 51,
  queryParams: {
    $select: 'title',
    search: '',
    fuzzy: true,
    $top: 5,
    suggesterName: 'querySuggester',
    'api-version': '2019-05-06',
    $filter: '',
    $orderby: 'locale desc,search.score() desc',
  },
};

export const AutoSuggestV2Constants = {
  cssClassName: 'supSuggestionItem',
  dataKeyName: 'autoSuggest_',
  characterMinimum: 2,
  characterMaximum: 51,
  queryParams: {
    query: '',
    locale: '',
    numResults: 5,
    highlightPreTag: '<b>',
    highlightPostTag: '</b>',
  },
};

export const AutoSuggestEnabledNamespaces = ['excel', 'powerpnt', 'winword'];

export const MockBranchingInsight: AlchemyInsightModel[] = [
  {
    'Title': null,
    'Description': "{\"schemaVersion\": \"3e7dd124-1823-4d6e-a9be-1f0b0b0f8d17\", \"meta\": {\"id\": \"3189568f-f99c-4a3a-a421-80ac6f832332\", \"title\": \"O365CXP_Security_Permission in Security & Compliance Center_What  \", \"description\": \"It helps the users to know which group roles to access for Security & Compliance features\", \"keywords\": null, \"team\": null, \"lastModifiedAt\": \"2020/11/23 12:38:23\", \"lastModifiedBy\": \" \", \"version\": \"O365CXP_Security_Permission in Security & Compliance Center_What  \", \"locale\": \"en-us\", \"supportAreaReference\": null, \"name\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat\"}, \"initialVariables\": null, \"topHeadingText\": null, \"startNodeId\": \"5e6b713b-492f-473c-bf60-7393e1f94bf6\", \"nodes\": [{\"type\": \"choiceNode\", \"id\": \"5e6b713b-492f-473c-bf60-7393e1f94bf6\", \"name\": \"Permissions needed to use features in S&C Center\", \"tags\": \"\", \"title\": null, \"text\": {\"contentType\": \"embeddedHtml\", \"content\": \"<p><b>Grant permissions to use features in the Office 365 Security &amp; Compliance Center</b><br><p>To grant a user permissions to perform a compliance task, add the user to the appropriate role group in the Office 365 Security &amp; Compliance Center.<br><br> To learn more, see <a href=\\\"https://go.microsoft.com/fwlink/?linkid=2114184\\\">Permissions needed to use features in the Security &amp; Compliance Center</a>.</p></p>\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993766\"}, \"outcomeSignal\": \"\", \"dynamicChoiceTargetNodeId\": \"\", \"staticChoices\": [{\"text\": {\"contentType\": \"embeddedPlainText\", \"content\": \"eDiscovery\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993757\"}, \"raiseEventName\": null, \"targetNodeId\": \"cdf728be-d909-4d07-9a9f-8eb978520d63\"}, {\"text\": {\"contentType\": \"embeddedPlainText\", \"content\": \"Data Loss Prevention (DLP)\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993758\"}, \"raiseEventName\": null, \"targetNodeId\": \"bad1533d-033b-40f2-9368-562f3485a9c2\"}, {\"text\": {\"contentType\": \"embeddedPlainText\", \"content\": \"Security Administration \", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993759\"}, \"raiseEventName\": null, \"targetNodeId\": \"ee6849f2-69cb-40d5-915a-84fc11265f92\"}, {\"text\": {\"contentType\": \"embeddedPlainText\", \"content\": \"Show me more options\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993760\"}, \"raiseEventName\": null, \"targetNodeId\": \"ca62832d-9f91-4b13-a9d3-f4e19b051dfd\"}], \"question\": {\"contentType\": \"embeddedHtml\", \"content\": \"Which of the following features would you like to assign permissions to?\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993767\"}}, {\"type\": \"choiceNode\", \"id\": \"ca62832d-9f91-4b13-a9d3-f4e19b051dfd\", \"name\": \"Show me more\", \"tags\": \"\", \"title\": null, \"text\": null, \"outcomeSignal\": \"\", \"dynamicChoiceTargetNodeId\": \"\", \"staticChoices\": [{\"text\": {\"contentType\": \"embeddedPlainText\", \"content\": \"Supervisory Review\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993761\"}, \"raiseEventName\": null, \"targetNodeId\": \"5ca14666-1085-4d12-ad21-c9ea6e9c2948\"}, {\"text\": {\"contentType\": \"embeddedPlainText\", \"content\": \"Sensitivity Labels\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993762\"}, \"raiseEventName\": null, \"targetNodeId\": \"d037244b-08fe-46d8-8c3f-39b3ef6df631\"}, {\"text\": {\"contentType\": \"embeddedPlainText\", \"content\": \"Audit Log\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993763\"}, \"raiseEventName\": null, \"targetNodeId\": \"a033e139-c952-47e5-83ef-be4de788d8e1\"}], \"question\": {\"contentType\": \"embeddedHtml\", \"content\": \"OK, here you go:\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993768\"}}, {\"type\": \"choiceNode\", \"id\": \"d037244b-08fe-46d8-8c3f-39b3ef6df631\", \"name\": \"Permissions for sensitivity labels\", \"tags\": \"\", \"title\": null, \"text\": {\"contentType\": \"embeddedHtml\", \"content\": \"<p><b>Permissions required to create and manage sensitivity labels</b><br><p>Members of your compliance team who will create sensitivity labels need permissions to the Microsoft 365 compliance center, Microsoft 365 security center, or the Security &amp; Compliance Center.<br><br>By default, global administrators for your tenant have access to these admin centers and can give compliance officers and other people access, without giving them all of the permissions of a tenant admin. For this delegated limited admin access, from the <b>Permissions</b> page, add users to the <b>Compliance Data Administrator</b>, <b>Compliance Administrator</b>, or <b>Security Administrator</b> role group.<br><br>To learn more, see <a href=\\\"https://go.microsoft.com/fwlink/?linkid=2133902\\\">Permissions required to create and manage sensitivity labels</a>.</p></p>\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993769\"}, \"outcomeSignal\": \"\", \"dynamicChoiceTargetNodeId\": \"\", \"staticChoices\": [{\"text\": {\"contentType\": \"embeddedPlainText\", \"content\": \"Yes\", \"$sid\": \"branching.yes\"}, \"raiseEventName\": null, \"targetNodeId\": \"7acec907-ee6e-4ade-bd06-3ec61c08c7a4\"}, {\"text\": {\"contentType\": \"embeddedPlainText\", \"content\": \"No\", \"$sid\": \"branching.no\"}, \"raiseEventName\": null, \"targetNodeId\": \"85ac32f5-accb-42b4-91ce-804922803d3d\"}], \"question\": {\"contentType\": \"embeddedHtml\", \"content\": \"Would you like to assign permissions for custom sensitive information type creation?\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993770\"}}, {\"type\": \"textNode\", \"id\": \"7acec907-ee6e-4ade-bd06-3ec61c08c7a4\", \"name\": \"Permissions for custom sensitive information type creation\", \"tags\": \"\", \"title\": null, \"text\": {\"contentType\": \"embeddedHtml\", \"content\": \"<p><b>Assign permissions for custom sensitive information type creation</b><br>Here's how:<ol><li><span>Sign in to the <a href=\\\"https://go.microsoft.com/fwlink/p/?linkid=2077143\\\">Security &amp; Compliance Center</a>, and then select <b>Permissions</b>.</span></li><li><span>Select <b>Compliance Administrator</b>, and then select <b>Edit</b>.</span></li><li><span>On the <b>Compliance Administrator</b> properties page, next to <b>Members</b>, select <b>Edit</b>.</span></li><li><span>On the <b>Editing Choose member</b> page, select <b>Choose members</b>.</span></li><li><span>On the <b>Choose members</b> page, select <b>+ Add</b>, and then select the name of the users you want to add.</span></li><li><span>When you've selected all of the users you want to add to the role group, select <b>Add &gt; Done</b>, and then select <b>Save</b>.<br><br>To learn more about information on creating custom sensitive types see <a href=\\\"https://go.microsoft.com/fwlink/?linkid=2134000\\\">Create a custom sensitive information type in the Security &amp; Compliance Center</a>.</span></li></ol></p>\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993771\"}, \"outcomeSignal\": \"\"}, {\"type\": \"textNode\", \"id\": \"85ac32f5-accb-42b4-91ce-804922803d3d\", \"name\": \"Ask for feedback\", \"tags\": \"\", \"title\": null, \"text\": {\"contentType\": \"embeddedHtml\", \"content\": \"<p>OK.\\u3000Thank you.<ol></ol></p>\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993772\"}, \"outcomeSignal\": \"\"}, {\"type\": \"choiceNode\", \"id\": \"cdf728be-d909-4d07-9a9f-8eb978520d63\", \"name\": \" eDiscovery permission  in S&C\", \"tags\": \"\", \"title\": null, \"text\": {\"contentType\": \"embeddedHtml\", \"content\": \"<p><b>Learn about eDiscovery-related roles in the Office 365 Security &amp; Compliance Center</b><br>eDiscovery Manager is the primary eDiscovery role group in the Office 365 Security &amp; Compliance Center. It contains two subgroups:<ul><li><span><b>eDiscovery Manager:</b> Members of this subgroup can view and edit only the cases to which they have access.</span></li><li><span><b>eDiscovery Administrator:</b> Members of this subgroup can access all cases. <br><br>To learn more, see <a href=\\\"https://go.microsoft.com/fwlink/?linkid=2114362\\\">Assign eDiscovery permissions in the Security &amp; Compliance Center</a>.</span></li></ul></p>\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993773\"}, \"outcomeSignal\": \"\", \"dynamicChoiceTargetNodeId\": \"\", \"staticChoices\": [{\"text\": {\"contentType\": \"embeddedPlainText\", \"content\": \"eDiscovery Manager\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993764\"}, \"raiseEventName\": null, \"targetNodeId\": \"59158381-a1b1-47ad-a150-f70230189e14\"}, {\"text\": {\"contentType\": \"embeddedPlainText\", \"content\": \"eDiscovery Administrator\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993765\"}, \"raiseEventName\": null, \"targetNodeId\": \"602f8f16-25cd-4c2f-9d63-ed0283d3a0b0\"}], \"question\": {\"contentType\": \"embeddedHtml\", \"content\": \"OK, which of the following role groups do you want to assign permissions to?\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993774\"}}, {\"type\": \"textNode\", \"id\": \"59158381-a1b1-47ad-a150-f70230189e14\", \"name\": \"Assign eDiscovery Manager permissions\", \"tags\": \"\", \"title\": null, \"text\": {\"contentType\": \"embeddedHtml\", \"content\": \"<p><b>Assign eDiscovery Manager permissions</b><br>Here's how:<ol><li><span>In the <a href=\\\"https://go.microsoft.com/fwlink/p/?linkid=2077143\\\">Office 365 Security &amp; Compliance Center</a>, select <b>Permissions</b> &gt; <b>eDiscovery Manager</b>.</span></li><li><span>In the <b>eDiscovery Manager</b> pane, next to <b>eDiscovery Manager</b>, select <b>Edit</b>.</span></li><li><span>In the <b>Editing Choose eDiscovery Manager </b> pane, select <b>Choose eDiscovery Manager</b>. </span></li><li><span>In the <b>Choose eDiscovery Manager</b> pane, select <b>+ Add</b>, and then select the users' names.</span></li><li><span>Select <b>Add</b> &gt; <b>Done</b> &gt; <b>Save</b>.</span></li></ol></p>\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993775\"}, \"outcomeSignal\": \"\"}, {\"type\": \"textNode\", \"id\": \"602f8f16-25cd-4c2f-9d63-ed0283d3a0b0\", \"name\": \"Assign eDiscovery Administrator permissions\", \"tags\": \"\", \"title\": null, \"text\": {\"contentType\": \"embeddedHtml\", \"content\": \"<p><b>Assign eDiscovery Administrator permissions</b><br>Here's how:<ol><li><span>In the <a href=\\\"https://go.microsoft.com/fwlink/p/?linkid=2077143\\\">Office 365 Security &amp; Compliance Center</a>, select <b>Permissions</b> &gt; <b>eDiscovery Manager</b>.</span></li><li><span>In the <b>eDiscovery Manager</b> pane, next to <b>eDiscovery Administrator</b>, select <b>Edit</b>. </span></li><li><span>In the <b>Editing Choose eDiscovery Administrator</b> pane, select <b>Choose eDiscovery Administrator</b>.</span></li><li><span>In the <b>Choose eDiscovery Administrator</b> pane, select <b>Add+</b>, and then select the users' names.</span></li><li><span>Select <b>Add</b> &gt; <b>Done</b> &gt; <b>Save</b>.</span></li></ol></p>\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993776\"}, \"outcomeSignal\": \"\"}, {\"type\": \"textNode\", \"id\": \"bad1533d-033b-40f2-9368-562f3485a9c2\", \"name\": \"Assign Data Loss Preventions (DLP) permissions\", \"tags\": \"\", \"title\": null, \"text\": {\"contentType\": \"embeddedHtml\", \"content\": \"<p><b>Assign Data Loss Prevention (DLP) permissions</b><br>OK. Here's how:<ol><li><span>In the <a href=\\\"https://go.microsoft.com/fwlink/p/?linkid=2077143\\\">Office 365 Security &amp; Compliance Center</a>, select <b>Permissions</b>.</span></li><li><span>Select <b>DLP Compliance Management</b>.</span></li><li><span>On the role group's properties page, next to <b>Members</b>, select <b>Edit</b>. </span></li><li><span> On the <b>Editing Choose member</b> page, select <b>Choose members</b>. </span></li><li><span> On the <b>Choose members</b> page, select <b>Add+</b>, and then select the name of each user that you want to add.</span></li><li><span>When you've selected all of the users you want to add to the role group, select <b>Add</b> &gt; <b>Done</b>, and then select <b>Save</b>.</span></li></ol></p>\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993777\"}, \"outcomeSignal\": \"\"}, {\"type\": \"textNode\", \"id\": \"ee6849f2-69cb-40d5-915a-84fc11265f92\", \"name\": \"Assign Security Administration permissions\", \"tags\": \"\", \"title\": null, \"text\": {\"contentType\": \"embeddedHtml\", \"content\": \"<p><b>Assign Security Administration permissions</b><br>Here's how:<ol><li><span>In the <a href=\\\"https://go.microsoft.com/fwlink/p/?linkid=2077143\\\">Office 365 Security &amp; Compliance Center</a>, select <b>Permissions</b> &gt; <b>Security Administrator</b>.</span></li><li><span>In the <b>Security Administrator</b> pane, next to <b>Members</b>, select <b>Edit</b>. </span></li><li><span>In the <b>Editing Choose members</b> pane, select <b>Choose members</b>. </span></li><li><span>In the <b>Choose members</b> pane, select <b>+ Add</b>, and then select the users' names.</span></li><li><span>Select <b>Add</b> &gt; <b>Done</b> &gt; <b>Save</b>.</span></li></ol></p>\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993778\"}, \"outcomeSignal\": \"\"}, {\"type\": \"textNode\", \"id\": \"5ca14666-1085-4d12-ad21-c9ea6e9c2948\", \"name\": \"Assign Supervisory Review permissions\", \"tags\": \"\", \"title\": null, \"text\": {\"contentType\": \"embeddedHtml\", \"content\": \"<p><b>Assign Supervisory Review permissions</b><br>Here's how:<ol><li><span>In the <a href=\\\"https://go.microsoft.com/fwlink/p/?linkid=2077143\\\">Office 365 Security &amp; Compliance Center</a>, select <b>Permissions</b> &gt; <b>Supervisory Review</b>.</span></li><li><span>In the <b>Supervisory Review</b> pane, next to <b>Members</b>, select <b>Edit</b>. </span></li><li><span>In the <b>Editing Choose member</b> pane, select <b>Choose members</b>. </span></li><li><span>In the <b>Choose members</b> pane, select <b>+ Add</b>, and then select the users' names.</span></li><li><span>Select <b>Add</b> &gt; <b>Done</b> &gt; <b>Save</b>.</span></li></ol></p>\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993779\"}, \"outcomeSignal\": \"\"}, {\"type\": \"textNode\", \"id\": \"a033e139-c952-47e5-83ef-be4de788d8e1\", \"name\": \"Assign log role\", \"tags\": \"\", \"title\": null, \"text\": {\"contentType\": \"embeddedHtml\", \"content\": \"<p><b>Assign an Audit Log role in the Office 365 Security &amp; Compliance Center</b><br><p>To search the Office 365 audit log, an admin must be assigned the View-Only Audit Logs role or the Audit Logs role in Exchange Online. These roles are assigned to the Compliance Management and Organization Management role groups by default. Global admins in Office 365 and Microsoft 365 are automatically added as members of the Organization Management role group.<br><br>To enable a user to search with the minimum level of privileges, create a custom role group in Exchange Online, add the View-Only Audit Logs role or Audit Logs role, and then add the user as a member of the new role group. <br><br>To learn more, see <a href=\\\"https://go.microsoft.com/fwlink/?linkid=2114193\\\">Manage role groups in Exchange Online</a> and <a href=\\\"https://go.microsoft.com/fwlink/?linkid=2114363\\\">Search the audit log in the Security &amp; Compliance Center</a>.</p></p>\", \"$sid\": \"O365CXPSecurityPermissioninSecurityComplianceCenterWhat.content.637480786581993780\"}, \"outcomeSignal\": \"\"}]}",
    'TextFormat': null,
    'BucketId': 9000722,
    'BucketName': 'OrgCompliance\\Catchall',
    'BucketConfidence': 0.2,
    'BucketPercentile': 0,
    'RuleID': 7363,
    'SolutionType': 'Branching',
    'SolutionId': '',
    'IsExpanded': true,
  },
];

export const enum IconNames {
  PremierBadgeIconName = 'Diamond',
  BusinessAssistBadgeIconName = 'Diamond',
  NeedHelpTabIconName = 'Unknown',
  HelpAndSupportIconName = 'Headset',
  ChromeMinimizeIcon = 'ChromeMinimize',
  RequestCreationTabIconName = 'Headset',
  RequestHistoryTabIconName = 'History',
  ComputerIcon = 'ThisPC',
  Clear = 'Clear',
  CloseIconName = 'ChromeClose',
  UserIconName = 'Contact',
  PanelNavBackIconName = 'ChromeBack',
  SolutionsCardRedEyeIconName = 'RedEye',
  SolutionsCardLikesIconName = 'Heart',
  FeedBackSuccessCheckIconName = 'SkypeCircleCheck',
  MoreIconName = 'More',
  MoreVerticalIconName = 'MoreVertical',
  PhoneIcon = 'Phone',
  EmptyFilterIcon = 'Filter',
  SolidFilterIcon = 'FilterSolid',
  ClearFilterIcon = 'ClearFilter',
  CheckMarkIcon = 'CheckMark',
  DownloadIcon = 'Download',
  RefreshIcon = 'Refresh',
  FeedbackIcon = 'Feedback',
  CollapseIcon = 'CollapseContent',
  ExpandIcon = 'ExploreContent',
  ChevronRightIcon = 'ChevronRight',
  ContactIconName = 'Contact',
  MailIconName = 'Mail',
  ChatIconName = 'Chat',
  OpenInNewWindowIconName = 'OpenInNewWindow',
  MailForwardIcon = 'MailForward',
  SystemIcon = 'System',
  SendMessage = 'Send',
  MessageIcon = 'Message',
  LocationDotIcon = 'LocationDot',
  ChevronDown = 'ChevronDown',
  DoubleChevronDown = 'DoubleChevronDown',
  ChevronUp = 'ChevronUp',
  DoubleChevronUp = 'DoubleChevronUp',
  Edit = 'Edit',
  Pin = 'Pinned',
  Unpin = 'Unpin',
  AdminALogoInverse32 = 'AdminALogoInverse32',
  Error = 'StatusErrorFull',
  DownArrowIcon = 'Down',
  TeleConsentToolTipIcon = 'Unknown',
  InfoIcon = 'Info',
  AttachmentsToolTip = 'Unknown',
  BlockedIcon = 'Blocked12',
  NeedHelpBubbleGetSupportIcon = 'Headset',
  CancelIcon = 'Cancel',
  PageList = 'PageList',
}

export class RequestConstants {
  public static TitleTextFieldCharLimit = 140;
  public static DateTimeFormat = '2-digit';
}

export const AADClientId = '4b233688-031c-404b-9a80-a4f3f2351f90';
export const OcvMsaTenantId = '9188040d-6c67-4c5b-b112-36a304b66dad';

export const BranchingTicketDataContext = 'ticketData';

export const RDSubwayNavMarginBottom = 9;
